import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      localCategory: {
        name: '',
        type: '',
        parent_id: 0,
        active: '1'
      },
      rules: {
        name: [
          {required: true, message: 'Bạn chưa nhập tên danh mục bài viết', trigger: 'change'},
          {max: 255, message: 'Tên danh mục bài viết phải nhỏ hơn 255 ký tự', trigger: 'change'}
        ],
        type: [
          {required: true, message: 'Bạn chưa chọn kiểu danh mục', trigger: 'change'}
        ],
        active: [
          {required: true, message: 'Bạn chưa chọn trạng thái', trigger: 'change'}
        ]
      },
      submitting: false
    }
  },
  computed: {
    ...mapGetters('category', ['categories', 'categoryHelpers'])
  },
  methods: {
    ...mapActions('category', ['getToTreeCategory', 'getCategoryHelpers']),
    newCategory () {
      this.localCategory = {
        name: '',
        type: '',
        parent_id: '',
        active: '1'
      }
      setTimeout(() => {
        this.watching = true
      }, 100)
    },
    getCategories () {
      this.localCategory.parent_id = ''
      this.getToTreeCategory({limit: -1, type: this.localCategory.type})
    }
  },
  watch: {
    localCategory: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  },
  mounted () {
    this.newCategory()
    if (!Object.keys(this.categoryHelpers).length) {
      this.getCategoryHelpers()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/category/mixins/index.js